import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { AdminUserEditModel } from '../../shared/models';
import { Store, select } from '@ngrx/store';
import { AppState } from 'app/app.reducers';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ClearAdminUserAction, LoadAdminUserAction, UpdateAdminUserAction } from '../../admin-store';
import { getAdminUser } from '../../admin-store/admin.selectors';
import { SubSink } from 'subsink';
import { UserProfile } from 'app/internal/user/models/user-profile';
import { getUserProfile } from 'app/internal/user/redux/user.selectors';

@Component({
  templateUrl: './admin-user.component.html',
  styleUrls: ['./admin-user.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class AdminUserComponent implements OnInit, OnDestroy {

  adminUser$: Observable<AdminUserEditModel>;
  userProfile$: Observable<UserProfile>;

  userId: string;
  userName: string;

  private subs = new SubSink();

  constructor(
    private store: Store<AppState>,
    private route: ActivatedRoute,
    private router: Router) {
    this.adminUser$ = this.store.pipe(select(getAdminUser));
    this.userProfile$ = this.store.pipe(select(getUserProfile));
  }

  ngOnInit(): void {
    this.route.params.subscribe(
      (params: Params) => {
        this.userId = params['id'];
        this.store.dispatch(new LoadAdminUserAction(this.userId));
      }
    );

    this.subs.sink = this.adminUser$.subscribe(user => {
      if (user) {
        this.userName = `${user.firstName} ${user.lastName}`;
      }
    });
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
    this.store.dispatch(new ClearAdminUserAction());
  }

  onCancel() {
    this.router.navigate(['/useraccount/admin/users']);
  }

  onSave(user: AdminUserEditModel) {
    this.store.dispatch(new UpdateAdminUserAction(user));
    this.router.navigate(['/useraccount/admin/users']);
  }
}
